import React, { useState, useEffect, useContext } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import AuthContext from "../../context/AuthContext";
import axios from "axios";
import { API_URL } from "../../components/api";

function DrawerTransfer() {
  const { user } = useContext(AuthContext);
  const [amountUSD, setAmountUSD] = useState(0);
  const [amountLBP, setAmountLBP] = useState(0);
  const [toDrawer, setToDrawer] = useState("");
  const [note, setNote] = useState("");
  const [drawers, setDrawers] = useState([]);
  const [payments, setPayments] = useState([]);
  const [clientreceipts, setClientReceipts] = useState([]);
  const [dealerreceipts, setDealerReceipts] = useState([]);
  const [pocketmoneyreceipts, setPocketMoneyReceipts] = useState([]);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [selectedReceipts, setSelectedReceipts] = useState([]);
  const [onlineCashOuts, setOnlineCashOuts] = useState([]);
  const [selectedOnlineCashOuts, setSelectedOnlineCashOuts] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [viewMode, setViewMode] = useState("receipts"); // payments or receipts

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [buttonColor, setButtonColor] = useState("#0056B3"); // State for button background color

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/inventory/exchange/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setDrawers(response.data);
        }
      } catch (error) {
        console.error("Error fetching drawers:", error);
        setAlertMessage("Failed to fetch drawer data.");
        setAlertType("danger");
        setShowAlert(true);
      }
    };

    fetchData();

    const fetchPayments = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(
          `${API_URL}/inventory/drawer/exchange/info/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              action: "Payment",
            },
          }
        );

        if (response.status === 200) {
          setPayments(response.data);
          console.log(response.data);
          console.log(payments);
        }
      } catch (error) {
        console.error("Error fetching payments:", error);
        setAlertMessage("Failed to fetch payments.");
        setAlertType("danger");
        setShowAlert(true);
      }
    };

    const fetchReceipts = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));

        const [clientsResponse, dealersResponse, pocketMoneyResponse] =
          await Promise.all([
            axios.get(`${API_URL}/inventory/drawer/exchange/info/`, {
              headers: { Authorization: `Bearer ${authTokens.access}` },
              params: {
                username: user.username,
                action: "Receipt",
                type: "Clients",
              },
            }),
            axios.get(`${API_URL}/inventory/drawer/exchange/info/`, {
              headers: { Authorization: `Bearer ${authTokens.access}` },
              params: {
                username: user.username,
                action: "Receipt",
                type: "Dealers",
              },
            }),
            axios.get(`${API_URL}/inventory/drawer/exchange/info/`, {
              headers: { Authorization: `Bearer ${authTokens.access}` },
              params: {
                username: user.username,
                action: "Receipt",
                type: "Pocket Money",
              },
            }),
          ]);

        if (clientsResponse.status === 200)
          setClientReceipts(clientsResponse.data);
        if (dealersResponse.status === 200)
          setDealerReceipts(dealersResponse.data);
        if (pocketMoneyResponse.status === 200)
          setPocketMoneyReceipts(pocketMoneyResponse.data);
      } catch (error) {
        setAlertMessage("Failed to fetch receipts.");
        setAlertType("danger");
        setShowAlert(true);
      }
    };

    const fetchOnlineCashOuts = async () => {
      try {
        const authTokens = JSON.parse(
          localStorage.getItem("authTokens")
        );

        const response = await axios.get(
          `${API_URL}/inventory/drawer/exchange/info/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              action: "OnlineCashOut",
            },
          }
        );

        if (response.status === 200) {
          setOnlineCashOuts(response.data);
        }
      } catch (error) {
        console.error(
          "Error fetching Online Cash Outs:",
          error
        );

        setAlertMessage(
          "Failed to fetch Online Cash Outs."
        );
        setAlertType("danger");
        setShowAlert(true);
      }
    };

    fetchPayments();
    fetchReceipts();
    fetchOnlineCashOuts();
  }, [user.username]);

  console.log(payments);

  useEffect(() => {
    calculateAmounts();
  }, [
    selectedPayments,
    selectedReceipts,
    selectedOnlineCashOuts,
  ]);

  const calculateAmounts = () => {
    let totalUSD = 0;
    let totalLBP = 0;

    const allReceipts = [
      ...clientreceipts,
      ...dealerreceipts,
      ...pocketmoneyreceipts,
    ];

    // Calculate total amounts for selected payments
    selectedPayments.forEach((id) => {
      const payment = payments.find((p) => p.payment_id === id);
      if (payment) {
        totalUSD -= parseFloat(payment.paid_amount_usd) || 0;
        totalLBP -= parseFloat(payment.paid_amount_lbp) || 0;
        totalLBP += parseFloat(payment.returned_lbp) || 0;
      }
    });

    // Calculate total amounts for selected receipts
    selectedReceipts.forEach((id) => {
      const receipt = allReceipts.find((r) => r.receipt_id === id);
      if (receipt) {
        totalUSD += parseFloat(receipt.paid_amount_usd) || 0;
        totalLBP += parseFloat(receipt.paid_amount_lbp) || 0;
        totalLBP -= parseFloat(receipt.returned_lbp) || 0;
      }
    });

    selectedOnlineCashOuts.forEach((id) => {
      const cashOut = onlineCashOuts.find(
        (item) =>
          item.online_drawer_transaction_id === id
      );

      if (cashOut) {
        totalUSD += parseFloat(cashOut.amount_usd) || 0;
        totalLBP += parseFloat(cashOut.amount_lbp) || 0;
      }
    });

    setAmountUSD(totalUSD);
    setAmountLBP(totalLBP);

    // Debugging logs
    console.log("Selected Payments:", selectedPayments);
    console.log("Selected Receipts:", selectedReceipts);
    console.log("Total USD:", totalUSD);
    console.log("Total LBP:", totalLBP);
  };

  const handleCheckboxChange = (type, id) => {
    if (type === "payment") {
      setSelectedPayments((prev) =>
        prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
      );
    } else if (type === "receipt") {
      setSelectedReceipts((prev) =>
        prev.includes(id) ? prev.filter((rid) => rid !== id) : [...prev, id]
      );
    } else if (type === "onlineCashOut") {
      setSelectedOnlineCashOuts((prev) =>
        prev.includes(id)
          ? prev.filter((cashOutId) => cashOutId !== id)
          : [...prev, id]
      );
    }
  };

  const handleSelectAll = () => {
    const allPayments = payments.map((payment) => payment.payment_id);
    const allReceipts = [
      ...clientreceipts,
      ...dealerreceipts,
      ...pocketmoneyreceipts,
    ].map((receipt) => receipt.receipt_id);

    const allOnlineCashOuts = onlineCashOuts.map(
      (cashOut) =>
        cashOut.online_drawer_transaction_id
    );

    setSelectedPayments(allPayments);
    setSelectedReceipts(allReceipts);
    setSelectedOnlineCashOuts(allOnlineCashOuts);
  };

  const handleTransfer = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/inventory/exchange/`,
        {
          username: user.username,
          amountUSD: amountUSD,
          amountLBP: amountLBP,
          toDrawer: toDrawer,
          note: note,
          selectedPayments: selectedPayments,
          selectedReceipts: selectedReceipts,
          selectedOnlineCashOuts: selectedOnlineCashOuts,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        setAlertMessage("Transfer successful!");
        setNote("");
        setAlertType("success");
        setShowAlert(true);

        // Disable the button
        setIsButtonDisabled(true);
        setButtonColor("grey");
        // Re-enable the button after 5 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
          setButtonColor("#0056B3");
        }, 5000);
      }
    } catch (error) {
      setAlertMessage("Transfer failed. Please try again.");
      setAlertType("danger");
      setShowAlert(true);
      console.error("Error during transfer:", error);
    }
  };

  const allReceipts = [
    ...clientreceipts,
    ...dealerreceipts,
    ...pocketmoneyreceipts,
  ];
  return (
    <div className="container mt-5">
      <h2 className="mb-4">Drawer Transfer</h2>
      {showAlert && (
        <Alert
          variant={alertType}
          onClose={() => setShowAlert(false)}
          dismissible
        >
          {alertMessage}
        </Alert>
      )}

      <Form>
        <Form.Group as={Row} controlId="formViewMode">
          <Form.Label column sm="2">
            View Mode
          </Form.Label>
          <Col sm="10">
            <Form.Control
              as="select"
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value)}
            >
              <option value="payments">Payments</option>
              <option value="receipts">Receipts</option>
              <option value="onlineCashOuts">Online Cash Outs</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Button
          variant="secondary"
          onClick={handleSelectAll}
          style={{ margin: "10px" }}
        >
          Select All Payments, Receipts & Online Cash Outs
        </Button>

        <div
          className="mt-4"
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            height: "200px", // Static height for the scrollable area
            overflowY: "scroll",
          }}
        >
          {viewMode === "payments" ? (
            <>
              <h5>Payments</h5>
              {payments.map((payment) => (
                <div key={payment.payment_id}>
                  <Form.Check
                    type="checkbox"
                    checked={selectedPayments.includes(payment.payment_id)}
                    label={`Payment ID: ${payment.description} - Amount (USD): ${payment.paid_amount_usd} - Amount (LBP): ${payment.paid_amount_lbp} Returned Amount (LBP): ${payment.returned_lbp}`}
                    onChange={() =>
                      handleCheckboxChange("payment", payment.payment_id)
                    }
                  />
                </div>
              ))}
            </>
          ) : viewMode === "onlineCashOuts" ? (
            <>
              <h5>Online Cash Outs</h5>

              {onlineCashOuts.map((cashOut) => (
                <div
                  key={
                    cashOut.online_drawer_transaction_id
                  }
                >
                  <Form.Check
                    type="checkbox"
                    checked={selectedOnlineCashOuts.includes(
                      cashOut.online_drawer_transaction_id
                    )}
                    label={
                      (cashOut.receipts || []).length
                        ? (cashOut.receipts || []).map(
                            (row) => (
                              <span
                                key={row.receipt_id}
                                style={{ display: "block" }}
                              >
                                {`${row.client_name} - Receipt #${
                                  row.receipt_id
                                } - ${(
                                  cashOut.payment_method || ""
                                ).toUpperCase()} - USD ${
                                  row.amount_usd
                                } / LBP ${row.amount_lbp}`}
                              </span>
                            )
                          )
                        : `Cash Out #${
                            cashOut.online_drawer_transaction_id
                          } - ${(
                            cashOut.payment_method || ""
                          ).toUpperCase()} - Amount (USD): ${
                            cashOut.amount_usd
                          } - Amount (LBP): ${cashOut.amount_lbp}`
                    }
                    onChange={() =>
                      handleCheckboxChange(
                        "onlineCashOut",
                        cashOut.online_drawer_transaction_id
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : (
            <>
              <h5>Receipts</h5>
              {allReceipts.map((receipt) => (
                <div key={receipt.receipt_id}>
                  {!receipt.first_name &&
                  !receipt.middle_name &&
                  !receipt.last_name ? (
                    <Form.Check
                      type="checkbox"
                      checked={selectedReceipts.includes(receipt.receipt_id)}
                      label={`${receipt.description}`}
                      onChange={() =>
                        handleCheckboxChange("receipt", receipt.receipt_id)
                      }
                    />
                  ) : (
                    <Form.Check
                      type="checkbox"
                      checked={selectedReceipts.includes(receipt.receipt_id)}
                      label={`${receipt.first_name} ${receipt.middle_name} ${receipt.last_name} - ${receipt.description}`}
                      onChange={() =>
                        handleCheckboxChange("receipt", receipt.receipt_id)
                      }
                    />
                  )}
                </div>
              ))}
            </>
          )}
        </div>

        <Form.Group as={Row} controlId="formToDrawer" className="mt-4">
          <Form.Label column sm="2">
            To Drawer
          </Form.Label>
          <Col sm="10">
            <Form.Control
              as="select"
              value={toDrawer}
              onChange={(e) => setToDrawer(e.target.value)}
            >
              <option value="" disabled>
                Select a drawer
              </option>
              {drawers.map((drawer) => (
                <option key={drawer.drawer_id} value={drawer.drawer_id}>
                  {drawer.drawer_name}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formAmountUSD">
          <Form.Label column sm="2">
            Amount (USD)
          </Form.Label>
          <Col sm="10">
            <Form.Control type="number" value={amountUSD} disabled />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formAmountLBP">
          <Form.Label column sm="2">
            Amount (LBP)
          </Form.Label>
          <Col sm="10">
            <Form.Control type="number" value={amountLBP} disabled />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formNote">
          <Form.Label column sm="2">
            {document.documentElement.lang === "ar" ? "ملاحظة (اختياري)" : "Note (optional)"}
          </Form.Label>
          <Col sm="10">
            <Form.Control
              as="textarea"
              rows={2}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Col>
        </Form.Group>

        <Button
          variant="primary"
          onClick={handleTransfer}
          style={{
            backgroundColor: buttonColor,
            color: "white",
            marginTop: "10px",
          }}
          disabled={isButtonDisabled} // Disable button based on state
        >
          Transfer
        </Button>
      </Form>
    </div>
  );
}

export default DrawerTransfer;
